module.exports = __webpack_public_path__ + "assets/img/survey_back.6115eb1f.png";